<template>
    <div class="contact-area ptb-100" id="contact">
        <div class="container">
            <div class="section-title">
                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Contactează-ne</span>
                <h2>Hai să discutăm despre proiectul tău<span class="overlay"></span></h2>
                <p>Adresa ta de email nu va fi făcută publică.<br>Toate câmpurile sunt obligatorii.</p>
            </div>

            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-image" data-tilt>
                        <img src="../assets/images/ASContact.png" alt="image">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <form id="contactForm" @submit.prevent="sendEmail">
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group">
                                        <input type="text" name="name" class="form-control" id="name" required placeholder="Numele tău">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group">
                                        <input type="email" name="email" class="form-control" id="email" required placeholder="Adresa de email">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <input type="text" name="phone_number" class="form-control" id="phone_number" required placeholder="Numărul de telefon">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <textarea name="message" id="message" class="form-control" cols="30" rows="6" required placeholder="Descrie pe scurt proiectul sau nevoia ta"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn" :disabled="formStatus.submitting">
                                        <i class="flaticon-tick"></i>
                                        {{ formStatus.submitting ? 'Se trimite...' : 'Trimite mesajul' }}
                                        <span></span>
                                    </button>
                                    <p v-if="formStatus.message" :class="formStatus.isError ? 'error-message' : 'success-message'">{{ formStatus.message }}</p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>   

<script>

export default {
    name: 'ASContact',
    data() {
        return {
            formStatus: {
                submitting: false,
                message: '',
                isError: false,
            },
        };
    },
    methods: {
        async sendEmail(e) {
            this.formStatus = { submitting: true, message: '', isError: false };
            const form = e.target;
            const formData = new FormData(form);

            const name = formData.get('name');
            const email = formData.get('email');
            const phone = formData.get('phone_number');
            const message = formData.get('message');

            const emailData = {
                from: email, // A no-reply or service-specific address
                replyTo: email,
                to: "contact@atelieruldesoftware.ro",
                subject: `Mesaj nou de la ${name} - atelieruldesoftware.ro`,
                html: `
                    Ai primit un mesaj nou de pe site-ul atelieruldesoftware.ro:<br><br>
                    <strong>Nume:</strong> ${name}<br>
                    <strong>Email:</strong> ${email}<br>
                    <strong>Telefon:</strong> ${phone}<br><br>
                    <strong>Mesaj:</strong><br>
                    <p>${message.replace(/\n/g, '<br>')}</p>
                `
            };

            try {
                // The actual URL of your email sending service
                const response = await fetch('https://ws.selfpromote.ro/sapi/api/email', {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer 87ebc664486668482cfebe4c82deea76db789a5ce502a4d48665bd0e3119955ca1942103b0305db86c77563b6adc7c1b6fb15069d7e56768f02d94ae3157f3fd775c1ecb998e4cb70ce65f008deefc873eb8603794c3f97f4acc5f2a385f4ff70b8a42d48d987f741dec732e320dfee481daa9125fdb24f82dddf9201852601e'
                    },
                    body: JSON.stringify(emailData)
                });

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({})); // Try to get error details
                    const errorMessage = errorData?.error?.message || `Eroare HTTP: ${response.status}`;
                    throw new Error(errorMessage);
                }

                this.formStatus.message = 'Mesajul a fost trimis cu succes!';
                this.formStatus.isError = false;
                form.reset();

            } catch (error) {
                console.error('A apărut o eroare la trimiterea emailului:', error);
                this.formStatus.message = 'A apărut o eroare. Te rugăm să încerci din nou.';
                this.formStatus.isError = true;
            } finally {
                this.formStatus.submitting = false;
            }
        }
    }
}
</script>

<style scoped>
.success-message {
    color: green;
    margin-top: 15px;
}
.error-message {
    color: red;
    margin-top: 15px;
}
</style>